import {useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {SearchBarProvider, SectionSearchBarContext} from './SearchBar'
import {Administrators} from './Administrators'

const Tabs = {
  Administrator: 1
}

export const Sections = props => {
  const {AdministratorTabProps} = props

  const {entity} = AdministratorTabProps

  const params = useParams()
  const [activeTab, setActiveTab] = useState(Tabs.Administrator)

  return (
    <div className="table-responsive-mask">
      <div className="vw-type-menu-wrapper vw-tab-menu-wrapper tab">
        <nav className="vw-type-menu vw-tab-menu">
          <ul>
            <li>
              <Link
                className={activeTab === Tabs.Administrator ? 'active' : ''}
                onClick={() => setActiveTab(Tabs.Administrator)}
              >
                Administrators
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <SearchBarProvider>
        {activeTab === Tabs.Administrator && (
          <Administrators
            SearchContext={SectionSearchBarContext}
            query={{
              adminOf: params[entity],
              entity,
              $populate: ['device', 'business', 'reseller', 'distributor', 'adminOf']
            }}
          />
        )}
      </SearchBarProvider>
    </div>
  )
}
